/**
 * The generic run-settings screen (step 4): the target version's own run
 * settings, then one picker per run credential (pick a saved EMR token or add
 * one inline). Any platform whose spec declares its settings can use it as is.
 */

import { CredentialsSection } from "@/features/experiments/credentials-section";
import { isSecret } from "@/features/experiments/run-package";
import { RunSettingsSection } from "@/features/experiments/run-settings-section";
import type { RunSettingsFormProps } from "./screens";

export function GenericRunSettingsForm({
  spec,
  values,
  refs,
  onSetting,
  onCredential,
}: RunSettingsFormProps) {
  const settings = spec?.run_settings ?? [];
  if (settings.length === 0 && !spec?.inputs.length)
    return <p className="text-[13px] text-muted">This agent takes no inputs, run settings or credentials.</p>;
  return (
    <>
      <RunSettingsSection
        settings={settings.filter((s) => !isSecret(s))}
        values={values}
        onChange={onSetting}
      />
      <CredentialsSection settings={settings.filter(isSecret)} refs={refs} onChange={onCredential} />
    </>
  );
}
